import Html from '../html'

const SignupUnopened = () => <Html name="signup-unopened" />

export default SignupUnopened
